import {useEffect, useState} from "react";
import useAlert from "../useAlert";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";

export function useCrudForm(repository, {id, onSuccess, onLoad}) {

    const {showSuccess, showError} = useAlert();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const {t} = useTranslation();

	const form = useForm({});

	const { register, handleSubmit,  errors, setValue, setError } = form;

	const onSubmit = async data => {

	    if (errors.length > 0) {
	        return false;
		}

        try {
	        setIsSubmitting(true);
            if (id) {
                data.id = id;
            }

            const response = await repository.save(data);

	        showSuccess(t('Data has been successfully saved'));
            onSuccess();
        } catch (error) {
	        showError(t('Form contains errors'));

	        if (error) {
                error.forEach(item => {
                    setError(item.Code, { message: t('ERROR_' + item.Message) })
                });
	        }  
            
        } finally {
	        setIsSubmitting(false);
        }
	 }

	 useEffect(async () => {

	     if (isNaN(id)) {
	         if (onLoad) {
                 onLoad(null);
             }
	         return;
         }

	     try {
	        setIsSubmitting(true);
             const response = await repository.getById(id);
             for (let key in response.data) {
                 if (response.data[key] != null) {
                    setValue(key, response.data[key]);
                 }
             }
             if (onLoad) {
                onLoad(response.data);
             }
         } catch (e) {
	         // error
             showError(e.text);
         } finally {
	        setIsSubmitting(false);
         }

	     return () => {
         };
     }, [id]);


	const hasError = (name) => {
	    return errors[name] ? true : false;
    }

	const errorMessage = (name) => {
	    return errors[name] ? errors[name].message : null;
    }

  return { form: form, onSubmit: handleSubmit(onSubmit), isSubmitting: isSubmitting, hasError: hasError, errorMessage: errorMessage };
}


